import { render, staticRenderFns } from "./ReportMobileOrdered.vue?vue&type=template&id=b48684a6"
import script from "./ReportMobileOrdered.vue?vue&type=script&lang=js"
export * from "./ReportMobileOrdered.vue?vue&type=script&lang=js"
import style0 from "./ReportMobileOrdered.vue?vue&type=style&index=0&id=b48684a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports